module.exports = __webpack_public_path__ + "static/img/loginBg4.40530f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/loginBg4.png
// module id = 0sx4
// module chunks = 3